import axios from 'axios';
import { useApiConfigStore } from '@store/api_config';

const publicClient = axios.create();

publicClient.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export interface SigningPageData {
  doc_title: string;
  project_name: string;
  conductor_name: string;
  signer_name: string;
  pdf_url: string;
  status: 'pending' | 'signed' | 'expired' | 'superseded';
  /** Initials pre-set by the conductor at request creation time. */
  initials?: string;
  _source?: string;
}

export interface SigningResult {
  success: boolean;
  message: string;
}

export const getSigningData = async (token: string): Promise<SigningPageData> => {
  try {
    const r = await publicClient.get(`/generated-documents/sign/${token}`);
    return r.data;
  } catch (e: any) {
    if (e?.response?.status === 404) {
      const r = await publicClient.get(`/signature-requests/sign/${token}`);
      return {
        doc_title: r.data.document_name,
        project_name: r.data.project_name,
        conductor_name: r.data.conductor_name,
        signer_name: r.data.signer_name,
        pdf_url: r.data.pdf_url,
        status: r.data.status,
        initials: r.data.initials,
        _source: 'signature-requests',
      } as SigningPageData;
    }
    throw e;
  }
};

export const submitSignature = async (
  token: string,
  signatureFile: File,
  initials?: string,
): Promise<SigningResult> => {
  const formData = new FormData();
  formData.append('signature', signatureFile);
  if (initials && initials.trim()) {
    formData.append('initials', initials.trim());
  }
  try {
    const r = await publicClient.post(`/generated-documents/sign/${token}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return r.data;
  } catch (e: any) {
    if (e?.response?.status === 404) {
      const r = await publicClient.post(`/signature-requests/sign/${token}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return r.data;
    }
    throw e;
  }
};
